<div class="w-100 mt-0 tool-container">
  <h4>Download Profile</h4>
  <mat-form-field class="me-3">
    <mat-label>Application</mat-label>
    <mat-select [(ngModel)]="downloadProfile.app">
      @for (app of applications; track app.value) {
        <mat-option [value]="app.value">
          {{ app.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field class="me-3">
    <mat-label>Profile ID</mat-label>
    <input matInput [(ngModel)]="downloadProfile.id" />
  </mat-form-field>
  <span class="radio-container ps-2 me-3">
    <mat-label>Download As</mat-label>
    <mat-radio-group [(ngModel)]="downloadProfile.downloadXml">
      <mat-radio-button [value]="true" class="me-3">XML</mat-radio-button>
      <mat-radio-button [value]="false">JSON</mat-radio-button>
    </mat-radio-group>
  </span>
  <button
    mat-raised-button
    color="primary"
    class="mx-auto"
    (click)="getProfileXml()"
    [disabled]="!downloadProfile.id || !downloadProfile.app"
  >
    Download
  </button>
  @if (downloadProfile.status) {
    <h4 class="col-12 {{ downloadProfile.statusClass }}">
      {{ downloadProfile.status }}
    </h4>
  }
</div>
